interface PageHeroProps {
  title: string;
  breadcrumbs: { label: string; path?: string }[];
  imageUrl: string;
}

const PageHero = ({ title, breadcrumbs, imageUrl }: PageHeroProps) => {
  return (
    <section className="relative h-64 sm:h-80 lg:h-96 flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div>
      <div className="absolute inset-0 bg-navy/40"></div>
      
      <div className="relative z-10 text-center px-4">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white mb-4 sm:mb-6">
          {title}
        </h1>
        <nav className="flex items-center justify-center space-x-2 text-white text-xs sm:text-sm">
          {breadcrumbs.map((crumb, index) => (
            <span key={index} className="flex items-center">
              {index > 0 && <i className="ri-arrow-right-s-line mx-1"></i>}
              {crumb.path ? (
                <a href={crumb.path} className="hover:underline">
                  {crumb.label}
                </a>
              ) : (
                <span>{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </section>
  );
};

export default PageHero;